/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BANDS = gql`
  query GetBand($filter: BandInput) {
    getBand(filter: $filter) {
      bandId
      bandName
      isChangeCostumeEnabled
      profileUpdateChange
      bandLogo
      primaryTheme
      secondaryTheme
      isMultiplePurchase
      openRegEnabled
      inviteExpireTime
      isUpdateExpiryEnabled
      partialRemainderEmailTriggerTime
      isPartialRemainderEmailTriggerEnabled
      unPaidRemainderEmailTriggerTime
      isUnPaidRemainderEmailTriggerEnabled
      sidebar {
        enabled
        name
      }
      enableNameCheck
      isLimitedFieldsSignUpEnabled
      blockedNames {
        email
        emailEnabled
        firstName
        firstNameEnabled
        lastName
        lastNameEnabled
      }
    }
  }
`;
